import posts from "../../data/posts";

const initialState = posts;
function postsReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
export default postsReducer;
